const PageCompLoader = () => {
    return (
        <div className="min-h-[60vh] flex flex-col items-center justify-center">
            <img className="h-12 w-auto mb-6" src={"/images/logo.png"} srcSet={"/images/logo.png"} alt="logo" />
            <div className="spinner-border spinner-border m-5" role="status" />
        </div>
    );
};

export default PageCompLoader;
